<template>
  <div class="app-change-personal-data">
    <slot name="txtBefore"></slot>
    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      form-personal-data-input>
      <PersonalDataForm
        :current-customer.sync="currentCustomer_"
        :email-repeat.sync="emailRepeat_"
        :invalid.sync="invalidPersonal"
      >
        <template v-for="slot in possibleChildSlotsFor('Personal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </PersonalDataForm>
      <EmailWithRepeat
        :email.sync = "currentCustomer_.email"
        :repeat.sync = "emailRepeat_"
        :invalid.sync = "emailInvalid"
      >
        <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </EmailWithRepeat>
      <dyn-slot :slot-data="{}"><slot name="txtAfterMail"></slot></dyn-slot>
      <div class="verification"  v-if="activateMailVerification">
        <SendVerificationMail
          v-if="activateMailVerification"
          :success-message = "mailSuccessMessage"
          :link= "mailLink"
          :show-forced="mailShowForced">
          <template v-for="slot in possibleChildSlotsFor('Verification')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </SendVerificationMail>
      </div>
      <PhoneDataForm
        v-if="activatePhone"
        :current-customer.sync="currentCustomer_"
        :invalid.sync="invalidPhone"
      >
        <template v-for="slot in possibleChildSlotsFor('Phone')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </PhoneDataForm>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import PersonalDataForm from '@/components/process/LIDL/PersonalData/PersonalDataForm.vue'
import PhoneDataForm from '@/components/process/LIDL/PersonalData/PhoneDataForm.vue'
import slotProxy from '@/mixins/slotProxy'
import syncProperty from '@/mixins/syncProperty'
import EmailWithRepeat from '@/components/process/generic/Email/EmailWithRepeat.vue'
import SendVerificationMail from '@/components/process/generic/Email/EmailVerification/SendVerificationMail.vue'

export default {
  name: 'ChangePersonalData',
  data () {
    return {
      invalidPhone: true,
      invalidPersonal: true,
      emailInvalid: true
    }
  },
  components: {
    SendVerificationMail,
    EmailWithRepeat,
    PhoneDataForm,
    PersonalDataForm
  },
  watch: {
    invalid: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(),
    syncProperty('currentCustomer', 'currentCustomer_'),
    syncProperty('emailRepeat', 'emailRepeat_')
  ],
  computed: {
    invalid () {
      if (this.activatePhone) {
        return this.invalidPhone || this.invalidPersonal || this.emailInvalid
      } else {
        return this.invalidPersonal
      }
    }
  },
  props: {
    activatePhone: {
      type: Boolean,
      default: false
    },
    activateMailVerification: {
      type: Boolean,
      default: true
    },
    mailSuccessMessage: {
      type: Boolean,
      default: false
    },
    mailLink: {
      type: String,
      required: true
    },
    mailShowForced: {
      type: Boolean,
      default: false
    }
  }
}
</script>
